import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, HardHat } from "lucide-react";

const ROLE_LABEL = { admin: "Administrator", salesperson: "Salesperson / PM", office: "Office / Estimator" };

export function AppShell({ children, title, actions }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <header className="sticky top-0 z-40 border-b border-slate-800 bg-slate-950/90 backdrop-blur-xl">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <button
            data-testid="brand-home-button"
            onClick={() => navigate("/")}
            className="flex items-center gap-3 group"
          >
            <div className="w-9 h-9 rounded-xl bg-orange-500 flex items-center justify-center shadow-lg shadow-orange-500/30 group-hover:scale-105 transition-transform">
              <HardHat className="w-5 h-5 text-slate-950" />
            </div>
            <div className="text-left leading-tight">
              <div className="font-display font-extrabold text-lg tracking-wide">AMAA</div>
              <div className="text-[10px] text-slate-500 -mt-1 uppercase tracking-widest">Construction AI</div>
            </div>
          </button>

          {title && <div className="hidden md:block font-display text-xl font-bold text-slate-300 truncate">{title}</div>}

          <div className="flex items-center gap-3">
            {actions}
            {user?.role === "admin" && (
              <Button
                data-testid="admin-users-nav"
                variant="ghost"
                size="sm"
                onClick={() => navigate("/admin/users")}
                className="text-slate-400 hover:text-orange-300 hidden sm:inline-flex"
              >
                Admin
              </Button>
            )}
            <div className="text-right hidden sm:block">
              <div className="text-sm font-semibold">{user?.name}</div>
              <div className="text-[10px] text-orange-400 uppercase tracking-wider">{ROLE_LABEL[user?.role]}</div>
            </div>
            <Button
              data-testid="logout-button"
              variant="ghost"
              size="icon"
              onClick={logout}
              className="text-slate-400 hover:text-white hover:bg-slate-800"
            >
              <LogOut className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto">{children}</main>
    </div>
  );
}
